import { render, staticRenderFns } from "./AssemblyBOMForm.vue?vue&type=template&id=141520a6&scoped=true"
import script from "./AssemblyBOMForm.vue?vue&type=script&lang=js"
export * from "./AssemblyBOMForm.vue?vue&type=script&lang=js"
import style0 from "./AssemblyBOMForm.vue?vue&type=style&index=0&id=141520a6&prod&scoped=true&lang=css"
import style1 from "./AssemblyBOMForm.vue?vue&type=style&index=1&id=141520a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141520a6",
  null
  
)

export default component.exports